module.exports = __webpack_public_path__ + "media/packs/images/flags/HU-0e867d93b72110e22532c31f761050e0.svg";